module.exports = __webpack_public_path__ + "img/badge_normativa.fe4b2f8c.jpg";